import React from "react";
import styled from "styled-components";
import theme from "../utils/theme";
import { SContainer, SBox } from "./common/MainSection";
/**
 * @brief v.2.0 메인페이지 고지사항
 */
export default function Alert() {
	return (
		<MainAlertContainer>
			<MainAlertBox>
				<p>안내사항</p>
				<ul className="pdbt">
					<li>
						- <strong>(주)이든파이낸셜 대출모집법인</strong> (대출모집법인
						등록번호 제2021-023호)
					</li>
					<li>
						- <a
							href="https://www.fss.or.kr/fss/bbs/B0000315/list.do?menuNo=200755"
							className="url"
							target="_blank"
							rel="noopener noreferrer"
						>
							금융감독원 온라인 대출모집법인 조회에서 신원확인이 가능합니다.</a>
					</li>
					<li>
						- (주)이든파이낸셜은 대출 모집업무 위수탁계약을 체결한 다수의
						금융기관(다올저축은행, 키움저축은행, 동원제일저축은행,
						JT친애저축은행, OSB저축은행, BNK캐피탈, OK저축은행)을
						대리중개합니다.
					</li>
					<li>
						- (주)이든파이낸셜은 금융기관의 금융상품에 대한 계약체결 권한이
						없으며, 대출 계약 체결권은 금융상품직접판매업자인 금융기관에게
						있습니다.
					</li>
					<li>
						- 본 서비스 이용과 관련하여 소비자는 금융소비자보호법 제44조와
						제45조에 따라 금융상품직접판매업자인 금융기관 및 금융상품
						판매대리중개업자인 - (주)이든파이낸셜에 손해배상을 청구할 수
						있습니다.
					</li>
					<li>
						- (주)이든파이낸셜은 본 서비스를 통한 대출진행에 있어 소비자로부터
						어떠한 금전적 대가도 요구하지 않으며, 금융기관을 대신하여 대출이자,
						원금상환 등을 받지 않습니다.
					</li>
					<li>
						- 본 서비스 이용을 위해 소비자가 입력한 개인정보와 신용정보는
						금융상품 직접판매업자인 금융기관이 보유 및 관리합니다.
					</li>
					<li>
						- 금융기관에서 지급하고 있는 대출 모집 수수료 기준은 개별
						금융회사 홈페이지에서 확인 가능합니다.
					</li>
					<li>
						- 대출 상품 이용 시, 해당 소비자의 신용점수는 하락할 수 있으며 이에
						따라 불이익이 발생할 수 있습니다.
					</li>
					<li>
						- 서비스는 회사와 서비스에 관한 위수탁계약을 체결한 제휴 금융회사 등의
						대출상품에 한하여 제공되는 것이며, 모든 금융회사의 전체 대출상품을
						대상으로 하지 않습니다.
					</li>
					<li>
						- 대출 상품 이용 시, 해당 소비자의 신용점수는 하락할 수 있으며
						이에 따라 불이익이 발생할 수 있습니다.
					</li>
					<li>
						- 통합 금리 범위 : 연 최저 3%~ 최고 20%, 최대 우대금리 5% 적용 가능,
						대출 기간 최장 50년 ~ 최단 1년. 대출 비용 총 예시는 아래와 같습니다.
						예시 : 100,000,000원을 연 5%로 36개월동안 원리금상환 시 총 납부금액은 107,895,240원입니다.
						(대출상품에 따라 달라질 수 있습니다.)
					</li>

				</ul>
			</MainAlertBox>
		</MainAlertContainer>
	);
}

const MainAlertContainer = styled(SContainer)`
  max-width: 430px;
  width: 100%;
  margin: 0 auto;
  background: #fafafc;
`;
const MainAlertBox = styled(SBox)`
  padding-top: 36px;
  padding-bottom: 36px;
  color: ${theme.gray70Color};
  font-size: 12px;
  font-weight: 300;
  line-height: 1.5;
  p {
    margin-bottom: 0px;
  }
  ul {
  	list-style: none;
    padding-left: 0;
    &.pdbt {
      padding-bottom: 12px;
      strong {
        color: ${theme.subColor};
        font-weight: 500;
      }
		li {
			margin: 3px;
		}
    }
  }
  a {
    text-decoration: none;
    color: ${theme.pointColor};
  }
`; 